import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function KeyboardShortcuts() {
  const nav = useNavigate();
  const last = useRef<{ key: string; t: number } | null>(null);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const target = e.target as HTMLElement | null;
      const typing = target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable);
      if (typing) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      const now = Date.now();
      const prev = last.current;
      last.current = { key: e.key, t: now };
      if (prev && prev.key === 'g' && now - prev.t < 900) {
        const target = e.key.toLowerCase();
        if (target === 's') { e.preventDefault(); nav('/leaderboard'); return; }
        if (target === 'a') { e.preventDefault(); nav('/activity'); return; }
        if (target === 'b') { e.preventDefault(); nav('/bets'); return; }
        if (target === 'n') { e.preventDefault(); nav('/news'); return; }
        if (target === 'p') { e.preventDefault(); nav('/players'); return; }
        if (target === 'c') { e.preventDefault(); nav('/knockout'); return; }
        if (target === 't') { e.preventDefault(); nav('/schedule'); return; }
        if (target === 'm') { e.preventDefault(); nav('/predictions'); return; }
      }
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [nav]);

  return null;
}
